import { identity, merge } from "lodash";
import { generateEndpoints, prefix } from "../helpers";

/**
 * This is the reource identifier
 * Everything will be under users.get, users.getAll, users.create, users.createAndSendEmail etc...
 */
const namespace = "profile";

const nameSpace = merge({}, generateEndpoints(namespace), {
  get: {
    getAll: () => [`${prefix}/${namespace}/auth/roles`],
  },
  post: {
  },
});

export default nameSpace;
